<script setup>
import {defineEmits, defineProps, onMounted, ref} from "vue";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import Forgot from "@/components/login/forgot.vue";

const emit = defineEmits(['login'])
const prop = defineProps(['account'])
const sms = ref()
const time = ref(0)
let timer = null;
const sendCodeLoading = ref(false)
const loginLoading = ref(false)
const form = ref({
  account: "",
  password: "",
  type: "scal",
  login_type: "2",
  sms_text: ""
})
const rule = {
  account: [
    {required: true, message: "请输入金熊猫会员手机号"},
    {
      validator: (rule, value, call) => {
        if (!/^1[3-9]\d{9}$/.test(value)) {
          call(new Error("请输入正确的手机号"))
        }
        call()
      }
    }
  ],
  password: [{required: true, message: "请输入短信验证码"}]
}
onMounted(() => {
  if (prop.account) {
    form.value.account = prop.account
  }
})
const getCode = (refs) => {
  clearTimeout(timer)
  refs.validateField("account", err => {
    sendCodeLoading.value = err
    if (err) {
      //获取短信验证码
      new axiosApi({
        encode: 'site',
        method: 'user/sms_code',
        body: {mobile: form.value.account}
      }).send((res) => {
        sendCodeLoading.value = false
        if (res.message.code !== "000") {
          return ElMessage.error({
            message: res.message.content
          })
        }
        form.value.sms_text = JSON.stringify(res.data)
        time.value = 120
        djs()
      }, () => {
        ElMessage.error({
          message: "短信验证码发送失败！",
          onClose: () => sendCodeLoading.value = false
        })
      })
    }
  })
}
const djs = () => {
  if (time.value < 1) {
    return clearTimeout(timer)
  }
  timer = setTimeout(() => {
    time.value--
    djs()
  }, 1000)
}
const loginFn = (refs) => {
  refs.validate(err => {
    loginLoading.value = err
    if (err) {
      new axiosApi({
        encode: "site",
        method: "user/login",
        body: form.value
      }).send((res) => {
        loginLoading.value = false
        emit("login", res)
      }, () => {
        loginLoading.value = false
        ElMessage.error({message: "登录异常"})
      })
    }
  })
}
</script>

<template>
  <el-form ref="sms" class="login-form" size="large" :model="form" :rules="rule">
    <el-form-item prop="account">
      <el-input placeholder="请输入会员手机号" v-model="form.account" clearable/>
    </el-form-item>
    <el-form-item prop="password">
      <el-input placeholder="请输入验证码" v-model="form.password" clearable>
        <template #suffix>
          <el-button type="danger" :disabled="time > 0" :loading="sendCodeLoading" plain @click="getCode(sms)">
            {{ time > 0 ? `${time}秒` : '获取验证码' }}
          </el-button>
        </template>
      </el-input>
    </el-form-item>
  </el-form>
  <forgot :sms="true"/>
  <div class="button">
    <el-button type="danger" round size="large" @click="loginFn(sms)" :loading="loginLoading">立即登录</el-button>
  </div>
</template>

<style scoped lang="less">
/deep/ .el-input{
  .el-input__wrapper{
    padding: 5px 10px;
    background-color: #e5e5e5;
    box-shadow: none;
  }
  .el-button{
    background: none;
  }
}
</style>
